import { render, staticRenderFns } from "./FormCheckboxField.vue?vue&type=template&id=b1aa4ef4&scoped=true"
import script from "./FormCheckboxField.vue?vue&type=script&lang=ts"
export * from "./FormCheckboxField.vue?vue&type=script&lang=ts"
import style0 from "./FormCheckboxField.vue?vue&type=style&index=0&id=b1aa4ef4&prod&scoped=true&lang=css"
import style1 from "./FormCheckboxField.vue?vue&type=style&index=1&id=b1aa4ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aa4ef4",
  null
  
)

export default component.exports